import apiClient from './apiClient';

/**
 * Service for Device Management and universal device operations.
 */
const deviceManagementService = {
    /**
     * Get all devices (deduplicated on backend).
     */
    async getDevices() {
        return await apiClient.get('/devices');
    },

    /**
     * Get unique devices.
     */
    async getUniqueDevices() {
        return await apiClient.get('/devices/unique');
    },

    /**
     * Get devices by category.
     */
    async getDevicesByCategory(category) {
        return await apiClient.get(`/devices/category/${category}`);
    },

    /**
     * Get devices by variant.
     */
    async getDevicesByVariant(variant) {
        return await apiClient.get(`/devices/variant/${variant}`);
    },

    /**
     * Add new device data.
     */
    async addDeviceData(deviceData) {
        return await apiClient.post('/devices', deviceData);
    },

    /**
     * Register a NEW machine (equipments row) — no TCU required.
     */
    async addEquipment(payload) {
        return await apiClient.post('/devices/equipment', payload);
    },

    /**
     * Last RECEIVED engine-hours meter per device (for the CSV export).
     */
    async getEngineHours(deviceIds) {
        return await apiClient.get(`/devices/engine-hours?ids=${encodeURIComponent(deviceIds.join(','))}`);
    },

    /**
     * Last engine-on / last GPS-on timestamp per device — when the machine last
     * actually RAN and when it last had a fix (Operations equipment view).
     * Returns { activity: { [deviceId]: { last_engine_on, last_gps_on } } }.
     */
    async getDeviceActivity(deviceIds) {
        return await apiClient.get(`/devices/activity?ids=${encodeURIComponent(deviceIds.join(','))}`);
    },

    /**
     * Update device data.
     */
    async updateDeviceData(deviceId, timestamp, updates) {
        return await apiClient.put(`/devices/${deviceId}/${timestamp}`, updates);
    },

    /**
     * Delete device data.
     */
    async deleteDeviceData(deviceId, timestamp) {
        return await apiClient.delete(`/devices/${deviceId}/${timestamp}`);
    },

    /**
     * Update device metadata (serial, category, etc)
     */
    async updateDeviceMetadata(deviceId, updates) {
        return await apiClient.put(`/devices/${deviceId}/metadata`, updates);
    },

    /**
     * Telematics overview — all TCU-connected devices with engine-ever-on flag.
     * Used by the Telematics Status landing page.
     */
    async getTelematicsStatus() {
        return await apiClient.get('/devices/telematics-status');
    }
};

export default deviceManagementService;
